import {useEffect} from 'react'
import '../../styles/Toast/ToastBase.css'
import successIcon from '../../media/toast/check-circle.svg'
import errorIcon from '../../media/toast/x-circle.svg'
import infoIcon from '../../media/toast/info-circle.svg'
import warningIcon from '../../media/toast/warning-circle.svg'
import {AnimatePresence, motion} from 'framer-motion/dist/framer-motion'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../reducers'
import {generalCloseToast} from '../../actions/general.actions'

const AlertToast = () => {
  const {title, message, tipo} = useSelector((state: State) => state.general.toast)
  const dispatch = useDispatch()

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(generalCloseToast())
    }, 6000)
    return () => clearTimeout(timer)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <AnimatePresence>
        <motion.div
          key='toast'
          className={`toast-container`}
          initial={{opacity: 0}}
          animate={{opacity: 1}}
          exit={{opacity: 0}}
          transition={{duration: 0.5}}
        >
          <div
            className={`toast-header ${
              tipo === 1 ? 'toast-success' : tipo === 0 ? 'toast-error' : tipo === 3 ? 'toast-warning' : tipo === 2 && 'toast-info'
            }`}
          >
            {tipo === 1 && <img src={successIcon} className='toast-img' alt='' />}
            {tipo === 0 && <img src={errorIcon} className='toast-img' alt='' />}
            {tipo === 2 && <img src={infoIcon} className='toast-img' alt='' />}
            {tipo === 3 && <img src={warningIcon} className='toast-img' alt='' />}
            <div className='toast-title'>{title}</div>
          </div>
          <div className='separador-t'> </div>
          <div className='toast-content'>
            <div className='toast-description m'>{message}</div>
          </div>
        </motion.div>
      </AnimatePresence>
    </>
  )
}

export default AlertToast
